const size = 60
const logoSize = size * 1.15
const padding = (size / 8) + 'px'
const easing = 'cubic-bezier(0.59, 0.17, 0.65, 0.97)'
const duration = 1.5
const step = 0.05

// Common styles for logo segments
const commonLogoStyles = {
  backgroundImage: 'url(/soloLoaderLogo.png)',
  backgroundSize: `${logoSize}px`,
  backgroundRepeat: 'no-repeat',
  height: size,
  marginRight: -logoSize * 0.016,
  marginLeft: -logoSize * 0.016,
}

// Logo segment configuration
const logoSegments = [
  { position: 0, width: logoSize * 0.26, delay: 0 },
  { position: logoSize * -0.265, width: logoSize * 0.26, delay: step },
  { position: logoSize * -0.53, width: logoSize * 0.2, delay: step * 2 },
  { position: logoSize * -0.735, width: logoSize * 0.26, delay: step * 3 },
]

// Helper function to create logo segment div
const createLogoSegment = (props: { position: number, width: number, delay: number }) => {
  const { position, width, delay } = props

  return (
    <div
      key={position}
      style={{
        ...commonLogoStyles,
        backgroundPosition: `${position}px 50%`,
        width,
        animation: `fadeInAndSlide ${duration}s ${delay}s infinite ${easing}`,
      }}
    />
  )
}

export const LoaderHtml = <div style={{
  backgroundColor: '#000000',
  width: size,
  height: size,
  padding,
  boxSizing: 'content-box',
  borderRadius: '15%',
  overflow: 'hidden',
  animation: 'logoFadeInOut 2s infinite linear',
  boxShadow: '0 0 10px 10px rgba(0, 0, 0, 0.1)',
}}>
  <div style={{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 0,
    marginTop: -size * 0.02,
  }}>
    {logoSegments.map((segment) => createLogoSegment(segment))}
  </div>
</div>

export const LoadingBarHtml = <div style={{
  width: '120px',
  height: '3px',
  backgroundColor: 'rgba(0, 0, 0, 0.05)',
  borderRadius: '3px',
  marginTop: '110px',
  position: 'absolute',
  overflow: 'hidden',
}}>
  <div style={{
    width: '100%',
    height: '100%',
    backgroundColor: '#5C5AEA',
    borderRadius: '2px',
    transformOrigin: 'left',
    animation: 'loadingBar 5.0s',
  }}
  />
</div>
